import zh_cn from './zh_cn.js'
import en_us from './en_us.js'

export default { zh_cn, en_us }



// WEBPACK FOOTER //
// ./src/locale/index.js